import { useQuery } from "@tanstack/react-query";

import { useApi } from "@/shared/api/use-api";

export const useGetStatsList = () => {
  const { statsControllerApi } = useApi();

  return useQuery({
    queryKey: [`getStatsList`],
    queryFn: ({ signal }) => statsControllerApi.getStatsList({ signal }),
  });
};
